import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const PersonComputer3 = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="164" viewBox="0 0 152 164" width="152" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M73.42 163.08c40 0 72.42-5.03 72.42-11.23s-32.42-11.23-72.42-11.23S1 145.65 1 151.85s32.42 11.23 72.42 11.23Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M61.44 60.87a75 75 0 0 0-2.72 4.28 127 127 0 0 0-8.09 16.81c-11 8.07-22.62 9.98-34.54 8.98a66 66 0 0 1-3.6-16.97c-.3-4.02-.2-7.78.22-11.27a63.6 63.6 0 0 0 29.11 4.39l.2-.02c5.82-.57 11.07-2.06 14.4-4.77q1.07-.87 1.84-1.9a4.2 4.2 0 0 0 3.17.47z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M50.64 81.95a223 223 0 0 0-5.98 16.85c-3.51 5.37-8.67 10.93-14.94 16.11l-.72-.89a91 91 0 0 1-6.41-9.31 79 79 0 0 1-6.5-13.77c11.91.99 23.54-.92 34.53-8.99z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M44.66 98.79a341 341 0 0 0-6.77 24.94 86 86 0 0 1-8.17-8.83c6.27-5.18 11.43-10.75 14.94-16.11Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M58.27 60.4a10 10 0 0 1-1.84 1.9c-3.33 2.71-8.58 4.2-14.39 4.77l-.2.02c-9.91.79-19.5-.59-29.11-4.39a52.5 52.5 0 0 1 11.59-27.27 14.75 14.75 0 0 1 16.46-4.69l.53.19c5.63 2.03 9.67 7.34 10.37 13.64.37 3.32.76 6.5 1.05 7.89 1.12 2.51 2.31 4.74 3.65 6.29q.89 1.05 1.89 1.64z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M47.2 45.63c-1.53 3.65-6.99 4.59-12.19 2.1s-8.19-7.46-6.67-11.1c1.53-3.65 6.99-4.59 12.19-2.1 5.21 2.49 8.19 7.46 6.67 11.1Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M113.45 79.89a36 36 0 0 1-15.73 3.96c-3.25-9.9-6.39-17.66-8.3-20 5.25-.8 14.79 5.29 24.03 16.03z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M129.02 104.22c-7.52 4.36-15.62 5.52-23.91 5.62a358 358 0 0 0-7.39-25.99 36 36 0 0 0 15.73-3.96 106 106 0 0 1 15.57 24.33Z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M137.93 138.71c-7.17 4.54-20.47 2.94-28.06.71 0-7.11-1.98-18.12-4.76-29.58 8.29-.1 16.39-1.27 23.91-5.62a96 96 0 0 1 8.91 34.49Z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M85.69 55.78c0 .96-.6 1.86-1.65 2.62l-.12-.09-.02-.02a21 21 0 0 0-4.79-2.88 14.2 14.2 0 0 0-12.19.42 22 22 0 0 0-3.68 2.26l-.09.06q-.19.1-.35.24c-1.05-.76-2.07-1.76-1.66-2.62.87-1.81 4.94-4.01 5.78-4.44 1.89-.51 4.12-.8 6.51-.8 2.05 0 3.99.21 5.68.6 3.92.87 6.59 2.63 6.59 4.65z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m63.13 58.16-.33.26-.02-.02q.17-.14.35-.24Z" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M84.04 58.41a13 13 0 0 1-4.13 1.83L77.3 66 75 80.74l-4.23-14.47-.07-.13-3.03-5.72a13 13 0 0 1-4.87-2l.33-.26s.05-.05.09-.06a22 22 0 0 1 3.68-2.26 14.2 14.2 0 0 1 12.19-.42 21 21 0 0 1 4.93 2.99z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M70.7 66.14c-5.49-.52-9.58-2.61-9.58-5.11v-5.24c0 .96.6 1.86 1.66 2.62l.02.02c1.16.86 2.85 1.55 4.87 2l3.03 5.72z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M85.69 55.78v5.24c0 2.32-3.51 4.28-8.39 4.97l2.61-5.76a13 13 0 0 0 4.13-1.83c1.05-.76 1.65-1.66 1.65-2.62Z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M111.39 112.57a147 147 0 0 1-4.01 2.01l-1.41.66q-1.85.85-3.79 1.63-2.02.83-4.14 1.61l-1.65.59-.44.15-1.83.62q-1.05.35-2.12.68-.78.25-1.59.48a182 182 0 0 1-4.59 1.28q-1.32.36-2.69.67-2.22.54-4.53 1.01l-1.88.38-1.76.33-.32.06-1.87.32q-.28.06-.56.09l-1.69.27-2 .31-2.22.31-1.47.19q-1.78.24-3.59.42a208 208 0 0 1-11.02.91l-1.44.08q-1.82.11-3.68.16l-2.13.08h-.4a191 191 0 0 1-5.2.09q-3.05.03-6.18 0 .3-1.3.69-2.83c1.66-6.68 4.35-16.6 8-26.92 1.44-4.06 3.02-8.19 4.75-12.2a115 115 0 0 1 8.09-15.74 62 62 0 0 1 2.72-4 43 43 0 0 1 5.67-6.42v1.18c0 2.5 4.09 4.59 9.58 5.11l.07.13 4.23 14.47L77.29 66c4.88-.7 8.39-2.66 8.39-4.98v-1.19a40 40 0 0 1 3.73 4.02c5.36 6.57 10.03 15.81 13.93 25.41a222 222 0 0 1 4.99 13.58 281 281 0 0 1 3.05 9.72z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M111.79 144.73c-26.16 5.34-51.93 5.59-77.26.13a7.07 7.07 0 0 1-5.38-8.65c.89-3.52 1.84-7.25 2.08-8.25 34.84.39 60.9-5.19 80.18-15.4 1.87 6.33 4.31 16.7 5.9 23.67a7.07 7.07 0 0 1-5.51 8.49z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M84.14 36.23c-2.84 2.5-6.55 4-10.61 4-3.9 0-7.47-1.38-10.26-3.69C63 22.41 64.32 11.01 74.93 7.81H75c7.96 1.19 9.25 13.62 9.15 28.41z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M86.81 18.6a9 9 0 0 0-4.36-1.07c-3.33 0-6.16 1.67-7.14 3.98l.02-.05h-4.08l.09.25a6.2 6.2 0 0 0-3.08-3.23 9 9 0 0 0-4.13-.95c-4.15 0-7.51 2.58-7.51 5.77v2.25c0 2.77 2.54 5.08 5.93 5.64a9 9 0 0 0 1.58.13c2.04 0 3.89-.62 5.24-1.64a5.2 5.2 0 0 0 2.27-4.13V23.3q0 .57-.15 1.12 0 .04-.03.08l.02-.08q.15-.54.15-1.12h3.3v2.25c0 2.77 2.54 5.08 5.93 5.64a9 9 0 0 0 1.58.13c2.04 0 3.89-.62 5.24-1.64a5.2 5.2 0 0 0 2.27-4.13V23.3c0-1.94-1.24-3.65-3.15-4.7z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M84.14 36.23q-.04 4.09-.16 8.34c-6.74-2.57-13.56-2.43-20.46-.19-.09-2.68-.2-5.3-.24-7.83a16.04 16.04 0 0 0 20.87-.31z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M97.96 42.67c-.94 2.59-14.2 7.61-14.2 7.61.07-2.46.15-3.25.22-5.71q.13-4.25.16-8.34c.1-14.79-1.19-27.22-9.15-28.41h-.05c.61-1.07.72-2.11.42-3.06C77.19.65 84.13.68 87.28 2.08c3.61 1.61 10.48 6.25 11.87 20.06.51 5.04.86 14.88-1.19 20.55z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M74.94 7.81h-.02c-10.61 3.2-11.93 14.59-11.66 28.73q.09 3.82.24 7.83c.1 2.49.2 3.34.28 5.9 0 0-12.56-3.12-13.48-6.09-1.49-4.85-2.38-17.45-1.91-22.07.66-6.54 3.54-15.96 12.16-20.06 6.84-3.26 13.71-.97 14.8 2.68.3.95.19 1.99-.42 3.06z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M75.33 18.04a5 5 0 0 0-.39 1.84h-3.3q0-.96-.39-1.84z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        d="M89.96 19.88q0 .57-.15 1.12c-.67 2.65-3.72 4.65-7.36 4.65a9 9 0 0 1-3.95-.86l8.31-9.61c1.91 1.05 3.15 2.76 3.15 4.7Z"
        fill={shades.primary.light}
      />
      <path
        d="m86.81 15.17-8.31 9.61A6 6 0 0 1 75.09 21a4 4 0 0 1-.15-1.12c0-3.19 3.36-5.77 7.51-5.77 1.62 0 3.13.39 4.36 1.07z"
        fill={shades.white}
      />
      <path
        className={strokeStyle}
        d="M89.96 19.88q0 .57-.15 1.12c-.67 2.65-3.72 4.65-7.36 4.65-1.44 0-2.8-.32-3.95-.86a6 6 0 0 1-3.41-3.78 4 4 0 0 1-.15-1.12c0-3.19 3.36-5.77 7.51-5.77 1.62 0 3.13.39 4.35 1.07 1.91 1.05 3.16 2.76 3.16 4.7z"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M87.69 24.01v2.25a8.7 8.7 0 0 1-5.24 1.64q-.81 0-1.58-.13c-.99-.92-.81-1.63 0-2.25a9 9 0 0 0 1.58.13c2.04 0 3.89-.62 5.24-1.64Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M80.87 27.76c-3.39-.56-5.93-2.87-5.93-5.64v-2.25q0 .57.15 1.12c.57 2.26 2.87 4.04 5.78 4.51-.82.62-1 1.33 0 2.25z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M89.96 19.88v2.25a5.2 5.2 0 0 1-2.27 4.13v-2.25A5.4 5.4 0 0 0 89.81 21q.15-.54.15-1.12Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        d="M71.64 19.88q0 .57-.15 1.12c-.67 2.65-3.72 4.65-7.36 4.65-1.45 0-2.8-.31-3.94-.86l8.07-9.73c2.04 1.03 3.38 2.8 3.38 4.82Z"
        fill={shades.primary.light}
      />
      <path
        d="m68.26 15.05-8.07 9.73a8 8 0 0 1-1.74-1.14l-.03-.02-.41-.4a5 5 0 0 1-.62-.8l-.16-.27q-.16-.28-.27-.57a4 4 0 0 1-.35-1.71q0-1.04.45-1.96c.8.32 1.76.51 2.8.51 2.75 0 4.98-1.32 4.98-2.94q-.01-.76-.59-1.38c1.48.02 2.84.36 4 .95z"
        fill={shades.white}
      />
      <path
        className={strokeStyle}
        d="M71.64 19.88q0 .57-.15 1.12c-.67 2.65-3.72 4.65-7.36 4.65-1.45 0-2.8-.32-3.94-.86a8 8 0 0 1-1.74-1.14l-.03-.02-.41-.4a5 5 0 0 1-.62-.8l-.16-.26q-.16-.29-.27-.57t-.19-.59a4.5 4.5 0 0 1 .3-3.08c.8.32 1.76.51 2.8.51 2.75 0 4.98-1.32 4.98-2.93q-.01-.76-.59-1.38 2.24.05 4 .95c2.04 1.03 3.38 2.8 3.38 4.82z"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M69.37 24.01v2.25a8.7 8.7 0 0 1-5.24 1.64q-.81 0-1.58-.13c-.99-.92-.81-1.63 0-2.25a9 9 0 0 0 1.58.13c2.04 0 3.89-.62 5.24-1.64Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M62.55 27.76c-3.39-.56-5.93-2.87-5.93-5.64v-2.25q0 .57.15 1.12c.57 2.26 2.87 4.04 5.78 4.51-.82.62-1 1.33 0 2.25z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M71.65 19.88v2.25a5.2 5.2 0 0 1-2.27 4.13v-2.25A5.4 5.4 0 0 0 71.5 21q.15-.54.15-1.12Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M89.83 18.8h3.21c2.7 0 2.24 2.89 2.24 2.89" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M64.85 15.49c0 1.62-2.23 2.94-4.98 2.94a8 8 0 0 1-2.8-.51c1.05-2.22 3.82-3.81 7.07-3.81h.13q.57.63.59 1.38z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m57.98 23.18.07.09-.08-.08z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M44.36 37.92c-.27-3.31.49-6.5.98-8.15.73.41 1.58.92 2.51 1.33-1.62 1.18-2.76 3.49-3.49 6.81zm6.27-9.31s-1.74-1.34-.96-2.68c.79-1.34 3.09.31 3.09.31-.75.26-1.46 1.08-2.13 2.37Zm5.27-11.14c-.79.54-1.55 1.52-2.27 3.25 0 0-2.26-1.89-1-3.25 1.26-1.37 3.27 0 3.27 0Zm4.74-5.37s-2.62-2.68-1.24-3.69c1.37-1 3.91.67 3.91.67a7 7 0 0 0-2.67 3.02Z"
        fill={shades.secondary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M64.63 14.12q-.37.58-.79.93c-.8.68-2.64.7-4.55.41a23 23 0 0 1-3.89-.94l-.18-.11c-1.21.25-2.58.93-2.13 2.68q.05.2.14.43.44 1.1 1.14 1.68c1.69 1.49 4.16.84 4.49-1.18.29.67.39 1.33.5 2.05.16 1.06-.41 2.25-1.31 3.17q-.45.48-.98.82a3.8 3.8 0 0 1-2.94.64l-.19-.02a11 11 0 0 0-1.8-2.12c-.79-.03-1.88.26-2.14 1.93q-.08.54.08 1.03c.22.7.75 1.3 1.41 1.72 1.18.75 2.74.95 3.59.16a6 6 0 0 0-.67-1.93l.11-.04c.93-.34 1.94-.58 2.92-.7a7.5 7.5 0 0 0 5.1 3.01l.37.06c.39 3.33-2.43 4.69-5.7 6.09a14 14 0 0 0-3.57 2.17 4.4 4.4 0 0 0-1.42 2.24c-.53 2.07-2.37 6.69-8.23 6.55l-.5-.02-.63-.06c-4.61-.52-8.51-3.34-11.02-7.45l-.18-.29a21 21 0 0 1-2.84-9.37c-.62-9.19 5.67-17.31 11.8-21 5.67-3.42 12.92-3.35 18.9-1.07-.91.68-2.3 2.15-1.07 4.13q.46.7 1.11 1.01.8.36 1.72.27a6.3 6.3 0 0 0 3.55-1.59 4.7 4.7 0 0 1-.21 4.7z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m58.87 18.04-.39-.72q.23.36.39.72Z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M47.85 31.11c-1.62 1.18-2.76 3.49-3.49 6.81-.27-3.31.49-6.5.98-8.15.73.41 1.58.92 2.51 1.33z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M39.96 11.97s7.07-2.15 12.94 1.08q1.34.74 2.33 1.38" strokeWidth={strokeWidth} />
      <path d="M41.02 27.47s1.4 1 3.33 1.81q.44.19.98.49" fill={shades.white} />
      <path className={strokeStyle} d="M41.02 27.47s1.4 1 3.33 1.81q.44.19.98.49" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M55.08 27.41c.21 1.44-.37 2.77-2.05 3.81-1.7 1.06-3.54.63-5.18-.12" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M36.89 22.7s2.67-2.67 6.07-3.38c3.01-.63 6.71.93 9.18 3.26" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M64.85 9.43a6.4 6.4 0 0 1-3.55 1.59q-.93.09-1.72-.27a2.7 2.7 0 0 1-1.11-1.01c-1.23-1.98.17-3.44 1.07-4.13q.74.27 1.44.6c2.07.94 3.27 2.08 3.88 3.23z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M58.87 18.04c-.33 2.02-2.8 2.67-4.49 1.18q-.7-.6-1.14-1.68-.09-.22-.14-.43c-.46-1.76.92-2.43 2.13-2.68l.18.11c1.18.78 1.98 1.46 2.54 2.08q.32.36.54.7z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M55.08 27.41c-.85.79-2.42.59-3.59-.16a3.2 3.2 0 0 1-1.41-1.72q-.15-.49-.08-1.03c.26-1.67 1.35-1.96 2.14-1.93a13 13 0 0 1 2.28 2.9q.53.99.67 1.93z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M131.04 120.73a6 6 0 0 0-.94.27 23 23 0 0 0-.4-3.65q.71 1.64 1.34 3.38Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M117.5 129.1c-2.09 2.11-4.47 3-6.9 3.63q-1.38-.48-2.47-1.08c-4.33-2.42-5.42-6.24-3.39-9.59 1.06-1.75 3.33-1.96 5.69-1.58 2.33.37 4.75 1.33 6.15 1.95l-.03 1.33c0 1.74.32 3.67.95 5.35z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M118.94 131.7a15 15 0 0 0-4.25 2.05l-1.5-.31q-1.4-.29-2.59-.71c2.43-.63 4.81-1.52 6.9-3.62.38.98.85 1.88 1.44 2.6z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M130.79 154.31c-5.87.26-10.82.04-14.53-.81l-.35-.96-.32-.97a27 27 0 0 1-.54-1.91c1.25-4.05 4.23-7.62 8.77-8.61.9 1.61 3.04 4.65 6.75 5.24.2 2.29.23 5.08.21 8.02z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M130.11 122.42c-.1 4.41-2.24 8.36-4.95 10.09q-1.32.84-2.74.93a4 4 0 0 1-1.83-.37 5 5 0 0 1-1.66-1.36 9 9 0 0 1-1.44-2.6c2.13 1.19 3.9.36 4.91-1.09a5 5 0 0 0 .83-3.95c-.56-3.14-3.66-3.54-5.94-2.89q-.36.1-.67.32c.34-4.47 1.8-10.45 6.44-10.81 1.72-.13 3.08.4 4.11 1.39 1.29 1.21 2.09 3.12 2.52 5.27a23 23 0 0 1 .4 5.08z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M136.3 140.39q-.32.55-.71.97a5.9 5.9 0 0 1-5.48 1.83 6 6 0 0 1-3.95-2.48 4 4 0 0 1-.39-.8 13 13 0 0 1-.55-2.93c.34.99 1 1.9 2.03 2.48 1.74.98 3.24.6 4.28-.36a5 5 0 0 0 1.54-3.59c0-3.23-2.15-4.28-4.3-4.23a13.8 13.8 0 0 0 3.29-10.7 4.5 4.5 0 0 1 4.54 2.41l.21.38q.63 1.3.99 3.05.14.7.25 1.46c.57 4.34-.02 9.62-1.77 12.51z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M145.84 129.38c-2.12-2.38-4.65-3.71-8.02-2.96a13 13 0 0 0-.99-3.05c1.09-.61 2.93-1.3 4.84-.38 1.59.77 3.14 3.22 4.17 6.39Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M142.66 139.41q.1.84.54 1.6.46.8 1.34 1.3.71.39 1.35.46a4.1 4.1 0 0 1-4.04 2 7 7 0 0 1-2.57-.8q-.54-.3-1.01-.74a7 7 0 0 1-.64-.68c2.75-5.46 2.61-10.29.44-14.67q-.1-.75-.25-1.46c3.36-.75 5.89.58 8.01 2.96.62 1.9 1.05 4.06 1.19 6.26a5 5 0 0 0-2.65.08c-1.24.35-1.94 2.04-1.71 3.69Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M128.79 131.27a22 22 0 0 1-3.66 3.48v-.89q0-.73.04-1.36c2.71-1.74 4.85-5.69 4.95-10.09v-1.42q.43-.17.94-.27.49-.11 1.04-.15c.42 3.83-.58 7.41-3.29 10.7z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M142.04 147.09a6 6 0 0 1-1.59 4.35 8 8 0 0 1-2.17-3.6c-.73-2.66-.11-4.38-.02-4.62q.47.44 1.01.74c.79.42 1.68.72 2.57.8q.2 1.26.2 2.32z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M120.59 133.06a17 17 0 0 0-2.3 1.47 11 11 0 0 0-1.79 1.96l-.3.45-.22.37q-.13.2-.23.42a10 10 0 0 0-.72 1.71q-.09.24-.14.47l-.05.13q-.06.19-.09.38-.07.22-.11.45l-.11.58-.08.52-.07.61-.02.33-.02.45-.02.71.02.67a18 18 0 0 0 .36 3.25l.07.37.12.57.17.71a23 23 0 0 0 .86 2.89l.35.96c-3.68-.84-6.14-2.32-7.07-4.57-.38-7.58 1.65-12.42 5.5-15.18a16 16 0 0 1 4.25-2.05 5 5 0 0 0 1.65 1.36z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M130.79 154.31c.02-2.94 0-5.73-.21-8.02a8 8 0 0 0 7.69-3.06c-.09.23-.72 1.95.02 4.62a8 8 0 0 0 2.17 3.6c-1.72 1.78-4.87 2.67-9.66 2.87z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M152.04 151.16c-1.47 2.84-21.25 3.14-21.25 3.14 4.79-.2 7.95-1.08 9.66-2.87a6 6 0 0 0 1.59-4.35s11.45 1.24 10 4.08Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M137.63 142.55c-.55-.67-.99-1.43-1.34-2.16 1.75-2.89 2.35-8.17 1.78-12.51 2.18 4.38 2.31 9.21-.44 14.67Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M138.27 143.23a8 8 0 0 1-7.69 3.06c-3.7-.59-5.85-3.62-6.75-5.24q1.09-.25 2.33-.34a6 6 0 0 0 3.95 2.49 5.9 5.9 0 0 0 6.18-2.8c.35.73.79 1.49 1.34 2.16q.3.36.63.68z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M126.16 140.71q-1.25.1-2.33.34c-4.54.99-7.53 4.56-8.77 8.6l-.17-.71-.12-.57-.07-.37q-.1-.54-.17-1.08-.16-1.11-.19-2.17l-.02-.67q0-.36.02-.71l.02-.45.02-.33a11 11 0 0 1 .26-1.71q.04-.23.11-.45.03-.19.09-.38l.05-.13.14-.47q.28-.88.72-1.71l.23-.42.22-.37.3-.45q.39-.52.82-1.02.45-.5.97-.94c.05-.08 1.11-.82 2.3-1.47q.82.4 1.83.38a5.5 5.5 0 0 0 2.73-.93q-.05 1-.03 2.24c.02 1.78.17 3.76.65 5.15q.15.42.39.8Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M123.33 125.14c0 .98-.33 2.03-.92 2.87-1.01 1.45-2.78 2.28-4.91 1.08-.64-1.68-.95-3.6-.95-5.34q0-.62.03-1.33l.06-.93q.31-.21.67-.32c2.28-.65 5.38-.24 5.94 2.89q.09.5.09 1.08z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M133.09 135.5a5 5 0 0 1-1.54 3.59c-1.04.96-2.54 1.34-4.28.36a4.4 4.4 0 0 1-2.03-2.48 28 28 0 0 1-.1-2.22 22 22 0 0 0 3.66-3.48c2.15-.04 4.3 1 4.3 4.23z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M147.02 138.58a9 9 0 0 1-1.13 4.19 4 4 0 0 1-1.35-.46 3.6 3.6 0 0 1-1.34-1.3 4 4 0 0 1-.54-1.6c-.22-1.65.47-3.34 1.71-3.69.83-.24 1.79-.3 2.65-.08q.09 1.47 0 2.94Z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M94.13 156.01H25.05a4.6 4.6 0 0 1-4.57-4.11l-5.04-47.5a4.6 4.6 0 0 1 4.57-5.09h69.08a4.6 4.6 0 0 1 4.57 4.11l5.04 47.5a4.6 4.6 0 0 1-4.57 5.09Z"
        fill={shades.white}
        strokeMiterlimit="10"
        strokeWidth={strokeWidth}
      />
      <path d="m62.43 123.75.96 7.82h-3.9l-.47-3.91h-3.9l.48 3.91h-3.89l-.96-7.82z" fill={shades.black} />
      <path className={strokeStyle} d="M123.47 54.4v5.69" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M126.52 57.25h-6.11" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M12.8 29.27v2.19" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M8.63 25.74H6.66" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M12.62 22.19V20" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M16.8 25.72h1.96" strokeWidth={strokeWidth} />
    </svg>
  );
};
